import PropTypes from 'prop-types';
import { MailIcon } from '../../../assets/images';
import { isUserWhoBlockedMe } from '../../../Helpers/Chat/BlockContact';
import ImageComponent from './ImageComponent';

const ProfileImage = ({
    emailContactInfo = false,
    chatType,
    userToken,
    imageToken,
    emailId,
    onclickHandler = null,
    profileImageView = null,
    userId,
    name,
    hideClassNameStatus = false,
    ...props
}) => {
    const isUserBlockedMe = isUserWhoBlockedMe(userId);

    return (
        <div
            className={`${hideClassNameStatus ? '' : `profile-image ${emailContactInfo ? 'email-info' : ''}`}`}
            onClick={onclickHandler ? onclickHandler : null}
        >
            <div className={`${hideClassNameStatus ? '' : 'image'}`}>
                <ImageComponent
                    chatType={chatType}
                    blocked={isUserBlockedMe}
                    userToken={userToken}
                    imageToken={imageToken}
                    onclickHandler={profileImageView}
                    name={name}
                    hideClassNameStatus={hideClassNameStatus}
                    classProps={props.classProps}
                />
            </div>
            {emailId && (
                <i className="email-icon">
                    <MailIcon />
                </i>
            )}
        </div>
    );
};

export default ProfileImage;

ProfileImage.propTypes = {
    emailContactInfo: PropTypes.bool,
    UserShortName: PropTypes.string,
    chatType: PropTypes.string,
    userToken: PropTypes.string,
    imageToken: PropTypes.string,
    temporary: PropTypes.bool,
    emailId: PropTypes.string,
    onclickHandler: PropTypes.func,
    profileImageView: PropTypes.func,
    userId: PropTypes.string,
    name: PropTypes.string,
    classProps: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
